import { For } from "solid-js";

type Row = { key: string; label: string; values: string[] };

type Props = {
  rows: Row[];
};

export function StackRows(props: Props) {
  return (
    <ul class="stack-rows">
      <For each={props.rows}>
        {(row) => (
          <li class="stack-row">
            <span class="stack-row-label">{row.label}</span>
            <span class="stack-row-value">{row.values.join(" · ")}</span>
          </li>
        )}
      </For>
    </ul>
  );
}
